// ParentGuide — modal FAQ untuk orang tua (Doc 09 §15.3).
// Reuse pattern F-05 ConfirmDialog: backdrop + panel + ESC + click outside.

import { STRINGS } from '@tm/shared'
import { trackEvent } from '../analytics/plausible.js'

const FAQ_ITEMS = [
  { qKey: 'parentGuideFaq1Q', aKey: 'parentGuideFaq1A' },
  { qKey: 'parentGuideFaq2Q', aKey: 'parentGuideFaq2A' },
  { qKey: 'parentGuideFaq3Q', aKey: 'parentGuideFaq3A' },
]

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function render(host) {
  const faqHtml = FAQ_ITEMS.map(
    ({ qKey, aKey }) => `
      <details class="tm-parent-guide__faq">
        <summary class="tm-parent-guide__faq-q">${escapeHtml(STRINGS[qKey])}</summary>
        <p class="tm-parent-guide__faq-a">${escapeHtml(STRINGS[aKey])}</p>
      </details>
    `,
  ).join('')

  host.innerHTML = `
    <div class="tm-parent-guide__backdrop" data-action="close"></div>
    <div class="tm-parent-guide" role="dialog" aria-modal="true" aria-labelledby="tm-parent-guide-title">
      <div class="tm-parent-guide__panel">
        <button type="button" class="tm-parent-guide__close" data-action="close" aria-label="${STRINGS.parentGuideClose}">×</button>
        <h3 id="tm-parent-guide-title" class="tm-parent-guide__title">${escapeHtml(STRINGS.parentGuideTitle)}</h3>
        <p class="tm-parent-guide__intro">${escapeHtml(STRINGS.parentGuideIntro)}</p>
        <div class="tm-parent-guide__faqs">${faqHtml}</div>
      </div>
    </div>
  `

  host
    .querySelectorAll('[data-action="close"]')
    .forEach((el) => el.addEventListener('click', close))
}

export function mountParentGuide({
  host,
  onClose,
  document: doc = typeof document !== 'undefined' ? document : null,
} = {}) {
  if (!host) throw new Error('ParentGuide: host is required')

  let open_ = false
  let escHandler = null

  function escListener(e) {
    if (e.key === 'Escape') close()
  }

  function open() {
    if (open_) return
    open_ = true
    render(host)
    if (doc && !escHandler) {
      escHandler = escListener
      doc.addEventListener('keydown', escHandler)
    }
    trackEvent('parent_guide_opened')
  }

  function close() {
    if (!open_) return
    open_ = false
    host.innerHTML = ''
    onClose?.()
    trackEvent('parent_guide_closed')
  }

  function isOpen() {
    return open_
  }

  function destroy() {
    if (escHandler && doc) {
      doc.removeEventListener('keydown', escHandler)
      escHandler = null
    }
    host.innerHTML = ''
    open_ = false
  }

  return { open, close, isOpen, destroy }
}
